module.exports = __webpack_public_path__ + "img/nar_2.68b8cbbd.gif";